import { apiAdd, apiDelete, apiGet, apiUpdate } from "../../../API/Service/apiClient";

export const handleGet_data = async (  
  {setListLoading,showToast,setItems,setEditIndex}
  ) => {
    setListLoading(true);
  let data={limit:100,page:1};
  try {
    const resData = await apiGet("sublimation_print_type", data);         
    setItems(resData?.data)    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setListLoading(false);
    setEditIndex(null);
  }
};

export const handleSubmit_data = async (  
  {setLoading,data,showToast,resetForm,setListLoading,setItems,setEditIndex,setFiles}
  ) => {
  setLoading(true);
  let formData=new FormData();
  formData.append("print_type_name", data?.print_type_name);
  if (data?.hasOwnProperty('imgpath')) {
    formData.append("imgpath", data?.imgpath); 
  }
  if(data?.id > 0){formData.append("id", data?.id); }
  try {
    let resData={};
    if(data?.id > 0){
      resData = await apiUpdate("sublimation_print_type", formData,{
        contentType: "multipart/form-data"
      });
    }else{
      resData = await apiAdd("sublimation_print_type", formData,{
        contentType: "multipart/form-data"
      });
    }
             
    if(resData?.data?.id > 0){
      handleGet_data({setListLoading,showToast,setItems,setEditIndex})      
      showToast("Cloth print type saved successfully","success")
      setFiles(null)
      resetForm();
    }else{
      showToast("Something went wrong! Please try again","danger")
    }    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);    
  }
};

export const handleDelete_data = async (  
  {item,showToast,setItems,setActionLoader}
  ) => {
      
  try {
    setActionLoader({deleteId:item?.id})
    const resData = await apiDelete("sublimation_print_type", item);
    if(resData?.data > 0){
      showToast("Deleted successfully", "success");
      setItems(prev => prev.filter(el => el.id !== item?.id));
    }else{
      showToast("Something went wrong! Please try again", "danger");  
    }         
    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setActionLoader({})
  }
};